/* eslint-disable react/no-unknown-property */
import { FC } from 'react';
import { ResourceType } from './utils';

type ResourceIconProps = {
  type: ResourceType;
  color?: string;
};

export const ResourceIcon: FC<ResourceIconProps> = ({ type, color = '#101828' }) => {
  switch (type) {
    case 'models':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="models-icon">
          <g id="cpu" clipPath="url(#clip0_25_11144)">
            <path
              id="Vector"
              d="M12 2.66669H3.99996C3.26358 2.66669 2.66663 3.26364 2.66663 4.00002V12C2.66663 12.7364 3.26358 13.3334 3.99996 13.3334H12C12.7363 13.3334 13.3333 12.7364 13.3333 12V4.00002C13.3333 3.26364 12.7363 2.66669 12 2.66669Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path id="Vector_2" d="M10 6H6V10H10V6Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_3" d="M6 0.666687V2.66669" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_4" d="M10 0.666687V2.66669" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_5" d="M6 13.3333V15.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_6" d="M10 13.3333V15.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_7" d="M13.3334 6H15.3334" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_8" d="M13.3334 9.33331H15.3334" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_9" d="M0.666626 6H2.66663" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_10" d="M0.666626 9.33331H2.66663" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_25_11144">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'workflows':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="workflows-icon">
          <g id="git-branch-01">
            <path
              id="Icon"
              d="M2 2V8.8C2 9.92011 2 10.4802 2.21799 10.908C2.40973 11.2843 2.71569 11.5903 3.09202 11.782C3.51984 12 4.0799 12 5.2 12H10M10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12ZM2 5.33333L10 5.33333M10 5.33333C10 6.4379 10.8954 7.33333 12 7.33333C13.1046 7.33333 14 6.4379 14 5.33333C14 4.22876 13.1046 3.33333 12 3.33333C10.8954 3.33333 10 4.22876 10 5.33333Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case 'modules':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="modules-icon">
          <g id="codesandbox">
            <path
              id="Vector"
              d="M14 10.6667V5.33335C13.9998 5.09953 13.938 4.86989 13.821 4.66746C13.704 4.46503 13.5358 4.29692 13.3333 4.18002L8.66667 1.51335C8.46397 1.39633 8.23405 1.33472 8 1.33472C7.76595 1.33472 7.53603 1.39633 7.33333 1.51335L2.66667 4.18002C2.46418 4.29692 2.29599 4.46503 2.17897 4.66746C2.06196 4.86989 2.00024 5.09953 2 5.33335V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path id="Vector_2" d="M5 2.80664L8 4.53997L11 2.80664" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_3" d="M5 13.1933V9.73333L2 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path id="Vector_4" d="M14 8L11 9.73333V13.1933" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
              id="Vector_5"
              d="M2.17999 4.64001L7.99999 8.00668L13.82 4.64001"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path id="Vector_6" d="M8 14.72V8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </svg>
      );
    case 'datasets':
    default:
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="datasets-icon">
          <g id="folder-open">
            <path
              id="Vector"
              d="M4.00004 11.3333L5.33337 8H14.6667L12.6667 13.3333C12.5361 13.5646 12.3395 13.7516 12.1019 13.8704C11.8644 13.9892 11.5967 14.0343 11.3334 14H2.66671C2.31309 14 1.97395 13.8595 1.7239 13.6095C1.47385 13.3594 1.33337 13.0203 1.33337 12.6667V3.33333C1.33337 2.97971 1.47385 2.64057 1.7239 2.39052C1.97395 2.14048 2.31309 2 2.66671 2H6.00004L7.33337 4H12C12.3537 4 12.6928 4.14048 12.9428 4.39052C13.1929 4.64057 13.3334 4.97971 13.3334 5.33333V8"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
  }
};
